 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AboutUs":"AboutUs","AdminSettings~Checkout~Contactanos~UserView~auth~dashboard~pages":"AdminSettings~Checkout~Contactanos~UserView~auth~dashboard~pages","Checkout":"Checkout","Contactanos":"Contactanos","UserView":"UserView","pages":"pages","AdminSettings":"AdminSettings","auth":"auth","dashboard":"dashboard","Cart":"Cart","Descubre~Public Layout~UserLayout":"Descubre~Public Layout~UserLayout","Public Layout":"Public Layout","UserLayout":"UserLayout","Favorites":"Favorites","FrequentQuestions":"FrequentQuestions","MyProgress":"MyProgress","PrivacyPolitic":"PrivacyPolitic","TermsConditions":"TermsConditions","campaign marketing":"campaign marketing","checkout complete payment":"checkout complete payment","Descubre":"Descubre","Home":"Home","UserDashboard":"UserDashboard","explore classes":"explore classes","users orders":"users orders","user classes":"user classes","components":"components","extra":"extra","instructors":"instructors"}[chunkId]||chunkId) + "." + {"AboutUs":"1d0c3a6e","AdminSettings~Checkout~Contactanos~UserView~auth~dashboard~pages":"85f91fdb","Checkout":"421b457c","Contactanos":"4b1c31b3","UserView":"ae3b8940","chunk-4c2a6abd":"84961733","chunk-4f32c61c":"8cecb7a4","chunk-0864f9c8":"199112a1","pages":"25d9666c","AdminSettings":"b054c9de","chunk-6c75c417":"87e5f8c0","auth":"9b52c6d1","dashboard":"c80a5dee","Cart":"baa21404","Descubre~Public Layout~UserLayout":"bf7c7b74","Public Layout":"35fcfb47","UserLayout":"0488cf55","Favorites":"9e273294","FrequentQuestions":"dd3615fc","MyProgress":"83d1c497","PrivacyPolitic":"88aa650e","TermsConditions":"b2688f52","campaign marketing":"c12bc326","checkout complete payment":"ca267c3e","chunk-90e7e3dc":"1dbe4ba6","Descubre":"533432e4","Home":"6db13e8a","UserDashboard":"8621f6ca","chunk-2ce36fbe":"6d63d137","chunk-8eb86814":"833ecd2f","explore classes":"3dca3485","chunk-39885cfe":"804d7b79","chunk-7561bf20":"fb856888","users orders":"ae219c2f","user classes":"c3a1b15b","chunk-aed6a596":"58f5c64d","chunk-c9b9fb50":"731f66ec","chunk-d0ff01b8":"cea5f2bd","components":"61782610","extra":"c23ef0eb","instructors":"8e041514","chunk-b7909280":"8453c762"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AboutUs":1,"Checkout":1,"Contactanos":1,"UserView":1,"chunk-0864f9c8":1,"pages":1,"AdminSettings":1,"chunk-6c75c417":1,"auth":1,"dashboard":1,"Cart":1,"Descubre~Public Layout~UserLayout":1,"UserLayout":1,"Favorites":1,"FrequentQuestions":1,"MyProgress":1,"PrivacyPolitic":1,"TermsConditions":1,"campaign marketing":1,"checkout complete payment":1,"chunk-90e7e3dc":1,"Descubre":1,"Home":1,"UserDashboard":1,"chunk-2ce36fbe":1,"chunk-8eb86814":1,"explore classes":1,"chunk-39885cfe":1,"chunk-7561bf20":1,"users orders":1,"user classes":1,"chunk-c9b9fb50":1,"chunk-d0ff01b8":1,"components":1,"extra":1,"instructors":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AboutUs":"AboutUs","AdminSettings~Checkout~Contactanos~UserView~auth~dashboard~pages":"AdminSettings~Checkout~Contactanos~UserView~auth~dashboard~pages","Checkout":"Checkout","Contactanos":"Contactanos","UserView":"UserView","pages":"pages","AdminSettings":"AdminSettings","auth":"auth","dashboard":"dashboard","Cart":"Cart","Descubre~Public Layout~UserLayout":"Descubre~Public Layout~UserLayout","Public Layout":"Public Layout","UserLayout":"UserLayout","Favorites":"Favorites","FrequentQuestions":"FrequentQuestions","MyProgress":"MyProgress","PrivacyPolitic":"PrivacyPolitic","TermsConditions":"TermsConditions","campaign marketing":"campaign marketing","checkout complete payment":"checkout complete payment","Descubre":"Descubre","Home":"Home","UserDashboard":"UserDashboard","explore classes":"explore classes","users orders":"users orders","user classes":"user classes","components":"components","extra":"extra","instructors":"instructors"}[chunkId]||chunkId) + "." + {"AboutUs":"e00782ce","AdminSettings~Checkout~Contactanos~UserView~auth~dashboard~pages":"31d6cfe0","Checkout":"e6304900","Contactanos":"d6a6c1c8","UserView":"b7c58a04","chunk-4c2a6abd":"31d6cfe0","chunk-4f32c61c":"31d6cfe0","chunk-0864f9c8":"aa3a36d6","pages":"a88eb27f","AdminSettings":"8b1c7ede","chunk-6c75c417":"ea86eef3","auth":"64c8fb16","dashboard":"44925f23","Cart":"ee203b76","Descubre~Public Layout~UserLayout":"41185add","Public Layout":"31d6cfe0","UserLayout":"b224442b","Favorites":"d725df9a","FrequentQuestions":"e4c32b4b","MyProgress":"22cb37da","PrivacyPolitic":"20e9a0a2","TermsConditions":"78df6a60","campaign marketing":"46bb121d","checkout complete payment":"8e75c6cf","chunk-90e7e3dc":"8f2e2cba","Descubre":"6a2f3f53","Home":"2a60ef9c","UserDashboard":"d931c528","chunk-2ce36fbe":"f800588e","chunk-8eb86814":"4396f5b0","explore classes":"456bc4c4","chunk-39885cfe":"7f7d94ba","chunk-7561bf20":"d20099e5","users orders":"c696fa2f","user classes":"42445ac6","chunk-aed6a596":"31d6cfe0","chunk-c9b9fb50":"7aa93fd3","chunk-d0ff01b8":"1c6b19b2","components":"9fcb9667","extra":"85fdc5c1","instructors":"5245e016","chunk-b7909280":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
